import { render, staticRenderFns } from "./PostCodeInput.vue?vue&type=template&id=baf1f508&scoped=true"
import script from "./PostCodeInput.vue?vue&type=script&lang=js"
export * from "./PostCodeInput.vue?vue&type=script&lang=js"
import style0 from "./PostCodeInput.vue?vue&type=style&index=0&id=baf1f508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf1f508",
  null
  
)

export default component.exports